import { CSSObject } from "styled-components";
import { StatCardVariant } from "./vfxStatCard";
import { useTheme } from "../../theme/ThemeProvider";

export interface StatCardStyles {
    card: CSSObject;
    inner: CSSObject;
    content: CSSObject;
    value: CSSObject;
    label: CSSObject;
    iconWrapper: CSSObject;
}

export const useStatCardStyles = (
    variant: StatCardVariant | undefined,
): StatCardStyles => {
    const theme = useTheme();
    const gradients: Record<StatCardVariant, string> = {
        orange: `linear-gradient(315deg, ${theme.palette.warning.light} 0%, ${theme.palette.accent.light} 100%)`,
        green: `linear-gradient(315deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 100%)`,
        blue: `linear-gradient(315deg, ${theme.palette.information.light} 0%, ${theme.palette.information.main} 100%)`,
    };

    const selectedGradient = gradients[variant ?? "blue"];

    return {
        card: {
            flex: 1,
            borderRadius: theme.spacePx.sp03,
            padding: theme.spacePx.sp04,
            color: theme.palette.white,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
            position: "relative",
            overflow: "hidden",
            background: selectedGradient,
            transition:
                "transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.25s ease",
            userSelect: "none",
            fontFamily: theme.font.family,
            "&::after": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background:
                    "linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 60%, rgba(0, 0, 0, 0.05) 100%)",
                pointerEvents: "none",
            },
            "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 10px 25px rgba(0, 0, 0, 0.12)",
            },
        },
        inner: {
            position: "relative",
            zIndex: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        },
        content: {
            display: "flex",
            flexDirection: "column",
        },
        value: {
            fontSize: "2.2rem",
            fontWeight: theme.font.weights.bold,
            margin: 0,
            lineHeight: 1.1,
            letterSpacing: "-0.5px",
        },
        label: {
            margin: `${theme.spacePx.sp01} 0 0`,
            fontSize: theme.font.sizes.md,
            fontWeight: theme.font.weights.semiBold,
            opacity: 0.85,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
        iconWrapper: {
            fontSize: "2.5rem",
            opacity: 0.35,
            position: "absolute",
            right: "-5px",
            bottom: "-5px",
            transform: "rotate(-10deg)",
            transition: "all 0.3s ease",
        },
    };
};

export default useStatCardStyles;